import { StrictMode } from "react";
// https://byby.dev/useeffect-run-twice
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import "./locale/i18next.d.ts";

// redux
import { Provider } from "react-redux";
import store from "./redux/store";

// testing and tracking
import Hotjar from "@hotjar/browser";

const siteId = 3530278;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);

// Get a reference to the root DOM node
const root = document.getElementById("root");

// Create a root
const rootReact = ReactDOM.createRoot(root);

// Render the app
rootReact.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
